import { message } from 'antd';

export const fmtDateTime = (iso?: string | null) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return iso;
  }
};

export const fmtDate = (iso?: string | null) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    });
  } catch {
    return iso;
  }
};

export const copyToClipboard = async (label: string, value?: string | null) => {
  try {
    await navigator.clipboard.writeText(String(value ?? ''));
    message.success(`${label} copied to clipboard`);
  } catch {
    message.error(`Could not copy ${label}`);
  }
};

export const isInvalidDocumentError = (rawError?: string | null) => {
  if (!rawError) return false;
  const text = String(rawError);
  return (
    /"id"\s*:\s*\[\s*"Must be a valid UUID\."\s*\]/i.test(text) ||
    /Must be a valid UUID\./i.test(text)
  );
};

export const isLikelyUsableFileUrl = (url?: string | null) => {
  if (!url) return false;
  const trimmed = String(url).trim();
  if (!trimmed) return false;
  return (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('/') ||
    trimmed.startsWith('blob:')
  );
};
